import cn from 'classnames';
import {Dispatch, SetStateAction} from 'react';

interface IProps {
  loan: ILoanType;
  selectedLoan: ILoanType | null;
  setSelectedLoan: Dispatch<SetStateAction<ILoanType | null>>;
}

const sampleBankLogo =
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTs6PYmiFBZ4-6DNm2U9YNbSUbSN8TxT7U6uw&s';

const LoanCard = ({loan, selectedLoan, setSelectedLoan}: IProps) => {
  const isSelected = loan.guid === selectedLoan?.guid;

  const handleSelectLoan = () => {
    if (selectedLoan === loan) {
      setSelectedLoan(null);
    } else {
      setSelectedLoan(loan);
    }
  };

  const rules = loan?.loan_rules
    .map(item => item.description)
    .map(desc => desc.split('\r\n'))
    .flat();

  return (
    <div
      className={cn(
        'p-3 shadow-sm rounded-xl cursor-pointer transition-all duration-100',
        {
          'border-[1px] border-farm-shop-500 bg-farm-shop-50': isSelected,
          'border border-gray-200 bg-white': !isSelected,
        },
      )}
      onClick={handleSelectLoan}
    >
      <div className="flex items-start">
        <img
          src={loan.bank_logo ?? sampleBankLogo}
          className="object-contain w-6 h-6"
        />

        <div className="flex gap-4 mr-3">
          <div className="flex flex-col gap-1 text-gray-700 text-md">
            <span>مبلغ وام</span>
            <span>مدت بازپرداخت</span>
            <span>درصد سود</span>
            <span>مبلغ هر قسط</span>
          </div>

          <div className="flex flex-col gap-1 text-md">
            <span>{loan.amount.toLocaleString()} تومان</span>
            <span>{loan.total_repayment_time} ماه</span>
            <span>{loan.profit_percentage} درصد</span>
            <div>
              <span>{loan.amount_per_installment.toLocaleString()} تومان</span>
              <span className="mr-2 text-sm text-red-500">
                {loan.total_number_of_installments} قسط
              </span>
            </div>
          </div>
        </div>
      </div>

      {rules.length > 0 && (
        <>
          <div className="w-full h-[1px] bg-gray-300 my-3" />

          <div className="flex flex-col text-gray-800 text-md">
            {rules.slice(0, 2).map((item, index) => (
              <div key={index} className="flex items-center gap-2">
                <div className="block w-[4px] h-[4px] bg-gray-500 rounded-full" />
                <span className="text-sm text-gray-700">{item}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LoanCard;
